'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import JBImage from 'components/essentials/JBImage';
import ProductCardPriceUI from 'components/consumer/product-card/ProductCardPrice/ProductCardPriceUI';
import useProductCardDataNext from 'hooks/useProductCardDataNext';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import avo from 'analytics/avo';
import { getVariantsByMatchedColorFirst } from 'components/consumer/consumer-search/advanced-search-next/components/AdvancedSearchProductHits/utils';
import SeeAllButtonNext from '../SeeAllButtonNext';

/**
 * Search Modal Product List - Mobile view (Next version)
 * Uses React InstantSearch v7 hooks instead of legacy connectStateResults
 * Renders products in a vertical list layout for mobile search modal
 */
const SearchModalProductListMobileNext = t0 => {
  const $ = _c(27);
  const {
    toggleSearchOpen
  } = t0;
  const {
    items: hits
  } = useHits();
  const {
    results
  } = useInstantSearch();
  const currentPage = useUserCurrentPageType();
  let t1;
  if ($[0] !== hits) {
    t1 = hits.slice(0, 3);
    $[0] = hits;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const limitedHits = t1;
  let t2;
  if ($[2] !== limitedHits) {
    t2 = limitedHits.map(_temp);
    $[2] = limitedHits;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const productIds = t2;
  let t3;
  if ($[4] !== productIds) {
    t3 = {
      productIds
    };
    $[4] = productIds;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    products,
    loading
  } = useProductCardDataNext(t3);
  let t4;
  if ($[6] !== hits || $[7] !== products) {
    let t5;
    if ($[9] !== hits) {
      t5 = product => ({
        ...product,
        variantsToShow: getVariantsByMatchedColorFirst(product, hits)
      });
      $[9] = hits;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = products.map(t5);
    $[6] = hits;
    $[7] = products;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const productsWithHighlightedVariantsFirst = t4;
  let t5;
  if ($[11] !== currentPage || $[12] !== results?.query || $[13] !== toggleSearchOpen) {
    t5 = () => {
      avo.productsSearched({
        query: results?.query ?? "",
        location: currentPage,
        searchTarget: avo.SearchTarget.PRODUCT_GRID
      });
      toggleSearchOpen?.();
    };
    $[11] = currentPage;
    $[12] = results?.query;
    $[13] = toggleSearchOpen;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  results?.query;
  const handleProductClick = t5;
  if (!limitedHits.length) {
    return null;
  }
  if (loading) {
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="instant-search-form__product-results flex-1 [border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10"><div className="text-brand block mt-[15px] mb-[7px] text-base font-bold">Products</div>{[0, 1, 2].map(_temp2)}</div>;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-brand block mt-[15px] mb-[7px] text-base font-bold">Products</div>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== handleProductClick || $[18] !== productsWithHighlightedVariantsFirst) {
    let t8;
    if ($[20] !== handleProductClick) {
      t8 = product_0 => <Link key={product_0.id} onClick={handleProductClick} to={product_0.variantsToShow?.[0]?.path ?? ""} className="text-base flex items-center font-bold text-gray px-0 py-4 [border-bottom:1px_solid_#f1f1f1] no-underline last:[border-bottom:0] [&_img]:object-contain [text-decoration:none]"><div className="mr-4 w-[100px] flex justify-center items-center"><JBImage className="object-contain m-5 opacity-100 max-h-full max-w-full" fit="clip" height={265} width={265} lazy={false} loader={false} src={product_0.variantsToShow?.[0]?.image ?? ""} trim="color" trimPad={20} /></div><div>{product_0.name}<ProductCardPriceUI originalPrice={product_0.variantsToShow?.[0]?.originalPrice} salePrice={product_0.variantsToShow?.[0]?.price} /></div></Link>;
      $[20] = handleProductClick;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t7 = productsWithHighlightedVariantsFirst.map(t8);
    $[17] = handleProductClick;
    $[18] = productsWithHighlightedVariantsFirst;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[22] !== toggleSearchOpen) {
    t8 = <div className="flex mt-5 justify-start [&_a]:[text-decoration:none]"><SeeAllButtonNext toggleSearchOpen={toggleSearchOpen} variant="mobile" /></div>;
    $[22] = toggleSearchOpen;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <div className="instant-search-form__product-results flex-1 [border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 [&_.ais-Hits-list]:flex [&_.ais-Hits-item]:p-2.5">{t6}{t7}{t8}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default SearchModalProductListMobileNext;
function _temp(hit) {
  return parseInt(hit.product_id || hit.objectID, 10);
}
function _temp2(i) {
  return <div key={i} className="flex items-center py-4 [border-bottom:1px_solid_#f1f1f1] last:[border-bottom:0]"><div className="mr-4 w-[100px] h-[100px] bg-gray-100 animate-pulse rounded" /><div className="flex-1"><div className="h-4 bg-gray-100 animate-pulse rounded mb-2 w-3/4" /><div className="h-3 bg-gray-100 animate-pulse rounded w-1/4" /></div></div>;
}